import { Api } from '@core/utils/api';

export const api = Api.create({
  ssr: true,
  requiredAuth: false,
  baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || '',
});
